// @file pinia store for landside quote modal state
import { defineStore } from 'pinia'
import { ref } from 'vue'

interface UtmParams {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
}

export const useQuotationFormDialogStore = defineStore('quotationFormDialog', () => {
  const searchParams = new URLSearchParams(window.location.search)
  const isQuoteModalOpen = ref((searchParams.get('get_quote') ?? '') === '1')
  const utmParams = ref<UtmParams>({})

  const openQuoteModal = (quoteUtmParams: UtmParams = {}): void => {
    isQuoteModalOpen.value = true
    utmParams.value = quoteUtmParams
  }

  const closeQuoteModal = (): void => {
    isQuoteModalOpen.value = false
    utmParams.value = {}
  }

  return {
    isQuoteModalOpen,
    utmParams,
    openQuoteModal,
    closeQuoteModal,
  }
})
